import React from 'react';
import ProfitAnalyzer from '../../components/business/ProfitAnalyzer';

/**
 * Dedicated Profit Analysis Page
 * Full-screen profit margin analyzer with advanced business intelligence
 */
const AdminProfitAnalysis = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">ניתוח רווחיות</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            מעקב מתקדם אחר מרווחי רווח וזיהוי הזדמנויות עסקיות
          </p>
        </div>
        <div className="flex items-center space-x-3 mt-4 sm:mt-0">
          <div className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
            <span>עדכון בזמן אמת</span>
          </div>
        </div>
      </div>

      {/* Full Profit Analyzer Component */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <ProfitAnalyzer />
      </div>
    </div>
  );
};

export default AdminProfitAnalysis;
